import React from "react"; 
import { useSelector, useDispatch } from "react-redux";
import { 
  getTickets, getServices, 
  getReviews } from "../store/actions/queueManagement";
  import { Link } from "react-router-dom";
  import Tickets from "../components/apps/queue-management/Tickets"
  import Queue from "../components/apps/queue-management/Queue";
  import Feedback from "../components/apps/queue-management/Feedback";



 
const QueueManagement = (props) => {
   
  const dispatch = useDispatch()
  var { organization, customerId } = useSelector((state) => state.organization);
  var { tickets, services, } = useSelector((state) => state.queueManagement);
  var { match } = props
  var components = [  
      { name: "queue",     page:Tickets, title:"Queue"},
      {name: "join",     page:Queue, title:"- join"},
      {name: "feedback",     page:Feedback, title:"- NPS"},
      // {name: "bookings",     page:Tickets, title:"Bookings"},
      // {name: "book",        page:AppointmentList, title:"Bookings"},
    ]
 
  React.useEffect(() => { 
    if(organization?.id?.length > 0){
      if(tickets?.length ===0)  dispatch(getTickets(organization?.id))
      if(tickets?.length ===0)  dispatch(getReviews(organization?.id))
      
       
      if(services?.length ===0)  dispatch(getServices(organization?.id))
  
    }
    },[ organization,  dispatch])

  
  var component = components.find(item => item?.name === match?.params?.pageId || '');
  let DynamicComponent
  document.title = "Queue " + component?.title || ''
  if(component!=null ) {
    DynamicComponent =  component.page
  }
  else {
    document.title = "Queue "
      DynamicComponent = Tickets
  }
    
  return (<>
    <nav class="navbar navbar-expand-lg bg-white mb-4">
      <div class="container-fluid">
        <Link class="navbar-brand"to="/queue">Queue</Link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-ex-6">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbar-ex-6">
          {/* <div class="navbar-nav me-auto">
             <Link class="nav-item nav-link" to="/queue/bookings">Bookings</Link>
            </div> */}
          <ul class="navbar-nav ms-lg-auto">
          <div class=" ">
            <div class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-end flex-md-row flex-column mb-3 mb-md-0">
              <div class="dt-buttons"><Link to="/queue/join" class="  add-new btn btn-primary" tabindex="0" type="button"  ><span><i class="bx bx-plus me-0 me-sm-2"></i><span class="">Queue</span></span></Link></div></div></div>
 
          </ul> 
        </div>
      </div>
    </nav>
  <DynamicComponent/> 
  </> )

}
 
export default QueueManagement
